/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/map/Status.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { _jac } from "@jac/prelude";
function linked_people(place, people) {
  let ids = place.evidence.filter(e => e.person_id).map(e => e.person_id);
  return people.filter(p => ids.includes(p.id)).map(p => p);
}
function pin_status(people) {
  if (people.map(p => (p.latest_status === "MISSING")).some(Boolean)) {
    return "MISSING";
  }
  if (people.map(p => (p.has_conflict || ["INJURED", "DECEASED"].includes(p.latest_status))).some(Boolean)) {
    return "REVIEW";
  }
  if (people.map(p => (p.latest_status === "FOUND_SAFE")).some(Boolean)) {
    return "FOUND_SAFE";
  }
  return "UNKNOWN";
}
function pin_label(status) {
  if ((status === "MISSING")) {
    return "Missing";
  }
  if ((status === "REVIEW")) {
    return "Needs review";
  }
  if ((status === "FOUND_SAFE")) {
    return "Reported safe";
  }
  return "No current status";
}
function pin_dot(status) {
  if ((status === "MISSING")) {
    return "bg-status-missing";
  }
  if ((status === "REVIEW")) {
    return "bg-status-warning";
  }
  if ((status === "FOUND_SAFE")) {
    return "bg-status-safe";
  }
  return "bg-status-neutral";
}
function current_reports(person) {
  let claims = person.claims.filter(c => ["MISSING", "FOUND_SAFE", "INJURED", "DECEASED"].includes(c.claim_type)).map(c => c);
  if (!_jac.builtin.bool(claims)) {
    return [];
  }
  let latest = claims.at((-1));
  if (person.has_conflict) {
    return claims.filter(c => ((!c.timestamp || !latest.timestamp) || (c.timestamp === latest.timestamp))).map(c => c);
  }
  return [latest];
}
export {current_reports, linked_people, pin_dot, pin_label, pin_status};
//# sourceMappingURL=Status.js.map
